
























import { Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';
import { Messages } from '../../i18n';

@Component
export default class DefaultRecommendations extends Vue {
  @Prop({ default: 4 })
  columns: number;

  @Prop({ required: true })
  recommendations: Result[];

  @Prop({ default: false })
  showAllButton: boolean;

  @Prop({ required: true })
  messages: Messages['recommendations'];

  @Prop({ required: true })
  showAllEvent: string;

  emitRecommendationsShowAllEvent() {
    this.$x.emit(this.showAllEvent);
  }
}
